module.exports = __webpack_public_path__ + "static/media/the-guardian-logo.e18a5691.svg";